/**
 * Convert a station name into a URL-safe Icecast mount slug.
 * Mirrors backend/utils/mount-slug.js so frontend previews match backend behaviour.
 */
export function stationNameToMountSlug(name, stationId) {
  if (name && typeof name === 'string') {
    const slug = name
      .toLowerCase()
      .trim()
      .replace(/&/g, 'and')
      .replace(/['']/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

    if (slug.length > 0) return slug;
  }
  return `station-${stationId}`;
}

export function stationNameToMount(name, stationId) {
  return `/${stationNameToMountSlug(name, stationId)}`;
}
